import React, {useEffect} from 'react';
import {NavigateFunction, useNavigate} from 'react-router-dom';
import Loading from '../../components/Loading/Loading';
import {useAccountContext} from '../../contexts/AccountContext';
import {useReviewContext} from '../../contexts/ReviewContext';
import {GlobalPermissionEnum} from '../../schema-types/globalTypes';

import {ReviewDetailsFragment} from '../../schema-types/ReviewDetailsFragment';
import {getHandoverTubestopRoute, reviewMustStopAtPrecursor} from './handoverNavigation';
import {useFeaturePermission} from '../../contexts/FeatureBoundary';

export {reviewMustStopAtPrecursor};

export const reviewDetailsHandoverNavigate = ({
  reviewDetails,
  accountId,
  navigate,
  canUseReportPack,
}: {
  reviewDetails?: ReviewDetailsFragment;
  accountId?: string;
  navigate: NavigateFunction;
  canUseReportPack: boolean;
}) => {
  if (!reviewDetails) return;

  const targetRoute = getHandoverTubestopRoute(reviewDetails, canUseReportPack);
  const basePath = `/account/${accountId}/review-journey/${reviewDetails.id}`;

  navigate({pathname: `${basePath}/${targetRoute}`}, {replace: true});
};

export const HandoverIndexRedirectPage: React.FC = () => {
  const {accountId} = useAccountContext();
  const {reviewDetails, reviewLoading} = useReviewContext();
  const navigate = useNavigate();
  const canUseReportPack = useFeaturePermission([
    GlobalPermissionEnum.can_access_report_pack,
  ]);
  useEffect(() => {
    if (reviewLoading || !reviewDetails) {
      return;
    }
    reviewDetailsHandoverNavigate({
      reviewDetails,
      accountId,
      navigate,
      canUseReportPack,
    });
  }, [
    reviewLoading,
    reviewDetails?.stage,
    reviewDetails?.statusOneview,
    reviewDetails?.precursorNotFinished,
    reviewDetails?.postcursorNotFinished,
    reviewDetails?.dateBooked,
    reviewDetails?.name,
    accountId,
    canUseReportPack,
  ]);
  return <Loading />;
};
